import React, { useContext } from "react";
import { PricingSummary } from "./PricingSummary";
import { GroupFormContext } from "../context/GroupFormContext";
import { useQuantity } from "../../../root/contexts/QuantityContext";
import { useBffData } from "../../../../hooks/queries";
import { MoqFooterMessage } from "./MoqFooterMessage";

export const PriceAndMOQ: React.FC<{}> = () => {
  const { data: bffData, isLoading } = useBffData();
  const { areFormFieldsInitialized } = useContext(GroupFormContext);
  const { totalQuantity, isAboveMOQ } = useQuantity();

  if (isLoading || !areFormFieldsInitialized) return <></>;

  if (totalQuantity === 0 || isAboveMOQ)
    return (
      <>
        <PricingSummary />
      </>
    );

  return <MoqFooterMessage moq={bffData!.minimumOrderQuantity} />;
};
